import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import KlarnaOptions from './klarnaOptions.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const GooglePayButtonType = makeShortcode("GooglePayButtonType");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='card' subtitle='object' mdxType="Item">
	Customize the appearance and behavior of the card fields in the checkout form.
	<Group summary='Properties' mdxType="Group">
		<Item title='cardholderName' subtitle='object' mdxType="Item">
			Options for the cardholder name input field.
			<Group summary='Properties' mdxType="Group">
				<Item title='required' subtitle='boolean' mdxType="Item">
					Whether the cardholder name is required. Only works if the cardholder name is visible.
				</Item>
				<Item title='visible' subtitle='boolean' label='Deprecated' mdxType="Item">
					Whether the cardholder name input field should be visible. This property is **deprecated**, set it on your
					Dashboard instead.
				</Item>
				<Item title='placeholder' subtitle='string | (options: { locale: string }) => string' mdxType="Item">
					The placeholder text to display in the cardholder name input field. It can be either a string or a function
					that returns a string. The function receives an options object as first argument.
				</Item>
			</Group>
		</Item>
		<Item title='cardNumber' subtitle='object' mdxType="Item">
			Customize the placeholder of the card number field.
			<Group summary='Properties' mdxType="Group">
				<Item title='placeholder' subtitle='string | (options: { locale: string }) => string' mdxType="Item">
					The placeholder text to display in the cardholder number input field. It can be either a string or a function
					that returns a string. The function receives an options object as first argument.
				</Item>
			</Group>
		</Item>
		<Item title='expiryDate' subtitle='object' mdxType="Item">
			Customize the placeholder of the expiry date field.
			<Group summary='Properties' mdxType="Group">
				<Item title='placeholder' subtitle='string | (options: { locale: string }) => string' mdxType="Item">
					The placeholder text to display in the expiry date input field. It can be either a string or a function that
					returns a string. The function receives an options object as first argument.
				</Item>
			</Group>
		</Item>
		<Item title='cvv' subtitle='object' mdxType="Item">
			Customize the placeholder of the CVV field.
			<Group summary='Properties' mdxType="Group">
				<Item title='placeholder' subtitle='string | (options: { locale: string }) => string' mdxType="Item">
					The placeholder text to display in the CVV input field. It can be either a string or a function that returns a
					string. The function receives an options object as first argument.
				</Item>
			</Group>
		</Item>
		<Item title='preferredFlow' subtitle='"DEDICATED_SCENE" | "EMBEDDED_IN_HOME"' mdxType="Item">
			Specify the preferred flow for entering card details.
		</Item>
	</Group>
    </Item>
    <Item title='redirect' subtitle='object' mdxType="Item">
	Options for payment methods that rely on redirecting.
	<Group summary='Properties' mdxType="Group">
		<Item title='returnUrl' subtitle='string' mdxType="Item">
			The URL to return to after the redirect process has completed.
		</Item>
		<Item title='forceRedirect' subtitle='boolean' mdxType="Item">
			Whether to always use a redirect flow, rather than a popup window, even if other options are available. Default
			value is `false`.
		</Item>
	</Group>
    </Item>
    <Item title='paypal' subtitle='object' mdxType="Item">
	Options for using PayPal as a payment method.
	<Group summary='Properties' mdxType="Group">
		<Item title='buttonColor' subtitle='"gold" | "blue" | "silver" | "white" | "black"' mdxType="Item">
			The color of the PayPal button.
		</Item>
		<Item title='buttonShape' subtitle='"pill" | "rect"' mdxType="Item">
			The shape of the PayPal button.
		</Item>
		<Item title='buttonSize' subtitle='"small" | "medium" | "large" | "responsive"' mdxType="Item">
			The size of the PayPal button.
		</Item>
		<Item title='buttonHeight' subtitle='number' mdxType="Item">
			The height of the PayPal button, in pixels.
		</Item>
		<Item title='buttonLabel' subtitle='"checkout" | "credit" | "pay" | "buynow" | "paypal" | "installment"' mdxType="Item">
			The label displayed on the PayPal button.
		</Item>
		<Item title='buttonTagline' subtitle='boolean' mdxType="Item">
			Whether to display the PayPal tagline beneath the button.
		</Item>
		<Item title='paymentFlow' subtitle='"DEFAULT" | "PREFER_VAULT"' mdxType="Item">
			The payment flow to use for the PayPal button.
		</Item>
		<Item title='onClick' subtitle='() => void' mdxType="Item">
			A function to be called when the PayPal button is clicked.
		</Item>
	</Group>
    </Item>
    <Item title='googlePay' subtitle='object' mdxType="Item">
	Options for using Google Pay as a payment method.
	<Group summary='Properties' mdxType="Group">
		<Item title='buttonType' subtitle='"long" | "short" | "book" | "buy" | "checkout" | "donate" | "order" | "pay" | "plain" | "subscribe"' mdxType="Item">
			<GooglePayButtonType mdxType="GooglePayButtonType" />
		</Item>
		<Item title='buttonColor' subtitle='"default" | "black" | "white"' mdxType="Item">
			The color of the Google Pay button.
		</Item>
		<Item title='buttonSizeMode' subtitle='"fill" | "static"' mdxType="Item">
			The size mode of the Google Pay button.
		</Item>
		<Item title='onClick' subtitle='() => void' mdxType="Item">
			A function to be called when the Google Pay button is clicked.
		</Item>
		<Item title='captureBillingAddress' subtitle='boolean' mdxType="Item">
			Whether to prompt the user to select a billing address.
		</Item>
	</Group>
    </Item>
    <Item title='applePay' subtitle='object' mdxType="Item">
	Options for using Apple Pay as a payment method.
	<Group summary='Properties' mdxType="Group">
		<Item title='buttonType' subtitle='"plain" | "buy" | "set-up" | "donate" | "check-out" | "book" | "subscribe"' mdxType="Item">
			The type of the Apple Pay button to display.
		</Item>
		<Item title='buttonStyle' subtitle='"white" | "white-outline" | "black"' mdxType="Item">
			The style of the Apple Pay button.
		</Item>
		<Item title='captureBillingAddress' subtitle='boolean' label='Deprecated' mdxType="Item">
			Whether to display a prompt for the user to enter their billing address during the payment process.
		</Item>
		<Item title='billingOptions' subtitle='object' mdxType="Item">
			Billing contact configuration options for Apple Pay.
			<Group summary='Properties' mdxType="Group">
				<Item title='requiredBillingContactFields' subtitle='("postalAddress" | "phoneNumber" | "emailAddress")[]' label='required' mdxType="Item">
					An array of string values that specify which required contact information fields should be collected during the checkout process.
				</Item>
			</Group>
		</Item>
		<Item title='shippingOptions' subtitle='object' mdxType="Item">
			Shipping contact configuration options for Apple Pay.
			<Group summary='Properties' mdxType="Group">
				<Item title='requiredShippingContactFields' subtitle='("postalAddress" | "name" | "phoneNumber" | "emailAddress")[]' label='required' mdxType="Item">
					An array of string values that specify which required contact information fields should be collected during the checkout process.
				</Item>
			</Group>
		</Item>
	</Group>
    </Item>
    <KlarnaOptions mdxType="KlarnaOptions" />
    <Item title='directDebit' subtitle='object' mdxType="Item">
	Options for using direct debit as a payment method.
	<Group summary='Properties' mdxType="Group">
		<Item title='customerCountryCode' subtitle='string' label='Required' mdxType="Item">
			The customer's two-letter country code.
		</Item>
		<Item title='companyName' subtitle='string' label='Required' mdxType="Item">
			The name of the company or organization accepting payments.
		</Item>
		<Item title='companyAddress' subtitle='string' label='Required' mdxType="Item">
			The address of the company or organization accepting payments.
		</Item>
		<Item title='customerName' subtitle='string' mdxType="Item">
			The name of the customer making the payment.
		</Item>
		<Item title='customerEmail' subtitle='string' mdxType="Item">
			The email address of the customer making the payment.
		</Item>
		<Item title='customerAddressLine1' subtitle='string' mdxType="Item">
			The first line of the customer's address.
		</Item>
		<Item title='customerAddressLine2' subtitle='string' mdxType="Item">
			The second line of the customer's address.
		</Item>
		<Item title='customerCity' subtitle='string' mdxType="Item">
			The city of the customer's address.
		</Item>
		<Item title='customerPostalCode' subtitle='string' mdxType="Item">
			The postal code of the customer's address.
		</Item>
		<Item title='iban' subtitle='string' mdxType="Item">
			The International Bank Account Number (IBAN) of the customer's bank account.
		</Item>
		<Item title='submitButtonLabels' subtitle='object' mdxType="Item">
			An object containing the text to display on the submit button for the Direct Debit form and mandate.
			<Group summary='Properties' mdxType="Group">
				<Item title='form' subtitle='string | (options: { locale: string }) => string' mdxType="Item">
					The label to display on the submit button for the Direct Debit form.
				</Item>
				<Item title='mandate' subtitle='string | (options: { locale: string }) => string' label='Required' mdxType="Item">
					The label to display on the submit button for the Direct Debit mandate.
				</Item>
			</Group>
		</Item>
	</Group>
    </Item>
    <Item title='giftCard' subtitle='object' mdxType="Item">
	Options for using gift cards as a payment method.
	<Group summary='Properties' mdxType="Group">
		<Item title='logoSrc' subtitle='string' label='Required' mdxType="Item">
			The source URL of the button logo.
		</Item>
		<Item title='background' subtitle='string' label='Required' mdxType="Item">
			The background color of the button.
		</Item>
		<Item title='logoAlt' subtitle='string' mdxType="Item">
			An alternative text for the button logo.
		</Item>
		<Item title='text' subtitle='string' mdxType="Item">
			The text to display on the button.
		</Item>
	</Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      